export const LISTING_UPDATES_PAGE_SIZE = 20

export const LISTING_UPDATE_ACTION = {
  addApplicant: 'add_applicant',
  bookViewing: 'book_viewing',
  create: 'create',
  updateAvailableFrom: 'update_available_from',
  updateDescription: 'update_description',
  updatePhotos: 'update_photos',
  updateRentPrice: 'update_rent_price',
  updateResponsibleManager: 'update_responsible_manager',
  updateStatus: 'update_status',
}

export const LISTING_UPDATE_ACTION_TRANSLATION_KEY = {
  [LISTING_UPDATE_ACTION.addApplicant]:
    'RentalPortal.ListingUpdateApplicantAddedKey',
  [LISTING_UPDATE_ACTION.bookViewing]:
    'RentalPortal.ListingUpdateViewingBookedKey',
  [LISTING_UPDATE_ACTION.create]: 'RentalPortal.ListingUpdateCreatedKey',
  [LISTING_UPDATE_ACTION.updateAvailableFrom]:
    'RentalPortal.ListingUpdateAvailableFromChangedKey',
  [LISTING_UPDATE_ACTION.updateDescription]:
    'RentalPortal.ListingUpdateDescriptionChangedKey',
  [LISTING_UPDATE_ACTION.updatePhotos]:
    'RentalPortal.ListingUpdatePhotosChangedKey',
  [LISTING_UPDATE_ACTION.updateRentPrice]:
    'RentalPortal.ListingUpdateRentChangedKey',
  [LISTING_UPDATE_ACTION.updateResponsibleManager]:
    'RentalPortal.ListingUpdateManagerChangedKey',
  [LISTING_UPDATE_ACTION.updateStatus]:
    'RentalPortal.ListingUpdateStatusChangedKey',
}
